import { crudService } from '../_services';
import { history } from '../_helpers';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';
import { stringUtils } from '../_utils';

export const camadasAction = {
    getCamada,
    getCamadaSelect,
    getCamadaById,
    onChangeProps,
    editCamadaInfo,
    createCamada,
    deleteCamadaById,
    clear
};

let filterModel = {
    Page: 1,
    Limit: 10,
    Term: ''
};

function getCamada(filterModel) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'camadas' + stringUtils.serialize(filterModel);
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeCamadasList(response.data.items, response.data.totalPages));
                }
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function getCamadaSelect() {
    return dispatch => {
        let apiEndpoint = 'camadas/select';
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    response.data.unshift({ value: '', text: ' SELECIONE ...' });
                    dispatch(changeCamadasList(response.data, null));
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function createCamada(payload) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'camadas/';
        crudService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    //history.push(ret.path);
                    alerts.success(ret.message);
                } else {
                    alerts.warning(response.request.responseText);
                }
            });
    };
}
function getCamadaById(id) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'camadas/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(editCamadasDetails(response.data));
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}
function editCamadaInfo(id, payload) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'camadas/' + id;
        crudService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    //history.push(ret.path);
                    alerts.success(ret.message);
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function deleteCamadaById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
        .then((willDelete) => {
            if (willDelete.value) {
                alerts.waiting();
                let apiEndpoint = 'camadas/' + id;
                crudService.deleteDetail(apiEndpoint)
                    .then((response) => {
                        if (response.request.status === 200) {
                            var ret = JSON.parse(response.request.responseText);
                            dispatch(deleteCamadasDetails());
                            dispatch(getCamada(filterModel));
                            alerts.success(ret.message);
                        } else {
                            alerts.warning(response.request.responseText);
                        }
                    }).catch((err) => {
                        console.log(err);
                        alerts.error(err);
                    });

            }
        });

    };
}
export function changeCamadasList(camada, totalPages) {
    return {
        type: "FETECHED_ALL_CAMADA",
        camada: camada,
        totalPages: totalPages
    };
}
export function clear() {
    return {
        type: "CAMADA_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE_CAMADA",
        props: props,
        value: value
    };
}
export function editCamadasDetails(camada) {
    return {
        type: "CAMADA_DETAIL",
        id: camada.id,
        nome: camada.nome,
        uploads: camada.uploads,
        excluido: camada.excluido,
    };
}
export function updatedUserInfo() {
    return {
        type: "CAMADA_UPDATED"
    };
}
export function createUserInfo() {
    return {
        type: "CAMADA_CREATED_SUCCESSFULLY"
    };
}
export function deleteCamadasDetails() {
    return {
        type: "DELETED_CAMADA_DETAILS"
    };
}